import { render } from "./Partnership Policy.vue?vue&type=template&id=79d6fed2&scoped=true"
const script = {}

import "./Partnership Policy.vue?vue&type=style&index=0&id=79d6fed2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d6fed2"]])

export default __exports__